var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBloma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 32,
    viewBox: "0 0 66 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9924 21.065C66.4125 20.7316 49.1451 18.8541 34.2222 31.7225C34.2222 31.7225 50.5584 33.1854 65.9924 21.065Z",
    fill: "#BCD491"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00760562 21.065C-0.415051 20.7316 16.8584 18.8541 31.7778 31.7225C31.7778 31.7225 15.4441 33.1854 0.00760562 21.065Z",
    fill: "#BCD491"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6902 2.0132C55.7565 15.6299 44.5373 23.7672 37.8336 27.2879C41.2382 23.2272 45.1908 16.0564 41.201 7.34629C43.9921 5.28185 48.241 2.91728 51.6902 2.0132ZM15.5314 1.9704C19.0591 2.89773 23.4224 5.35001 26.258 7.47997C23.7908 12.802 23.1638 19.921 29.4759 27.2974C22.7913 23.8079 11.4469 15.6569 15.5314 1.9704ZM34.0228 9.53674e-06C49.4138 15.0133 36.2929 27.1384 33.6317 29.3333C24.87 21.6315 25.0081 14.2255 27.2839 8.78564C28.5121 5.85938 31.3088 1.8552 34.0228 9.53674e-06Z",
    fill: "#96C447"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBloma);
export default __webpack_public_path__ + "static/media/logo-bloma.f9cdcca7.svg";
export { ForwardRef as ReactComponent };